import axios from 'axios'
import config from 'config'
import get from 'lodash/get'
import moment from 'moment-timezone'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import {useLocation} from 'react-router-dom'
import ReportAccordion from 'components/ReportAccordion'
import ScrollToTopButton from 'components/ScrollToTopButton'

import {
  Accordion, Card, Divider, Header, Icon, Loader, Grid, GridColumn
} from 'semantic-ui-react'

import Page from 'components/Page'
import './style.scss'

const {apiUrl} = config

const Changelog = (props) => {
  const dataUpdated = get(props, 'data.dataUpdated')
  const reportsUpdated = get(props, 'data.reportsUpdated')
  const message = get(props, 'data.message')

  const panels = [
    {
      key: 1,
      title: 'Release Notes',
      content: {
        content: (
          <div className="changelog__release-notes" style={{padding: "0 1.5rem"}}>
            <ReactMarkdown children={message} />
          </div>
        )
      }
    }
  ]

  return(
    <React.Fragment>
      <p>
        This list is reviewed and updated on a quarterly basis.
        This list below was developed based on data from {moment(dataUpdated).format('MMMM YYYY')},
        and was last updated in {moment(reportsUpdated).format('MMMM YYYY')}.
      </p>
      { (message && message.trim() !== '') &&
      <Accordion fluid panels={panels} exclusive={false} />
      }
      <Divider hidden />
    </React.Fragment>
  )
}

function CAHRAs() {
  const [loadingReports, toggleLoadingReports] = useState(true)
  const [reports, setReports] = useState([])
  const [isChangelogLoading, toggleChangelogLoading] = useState(true)
  const [changelog, setChangelog] = useState(null)
  const {hash} = useLocation()

  useEffect(() => {
    const fetchLastUpdated = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/changelog/latest`)
        const { message, data_updated, reports_updated } = response.data

        setChangelog({
          message: message,
          dataUpdated: data_updated ? new Date(get(data_updated, '$date')) : null,
          reportsUpdated: reports_updated ? new Date(get(reports_updated, '$date')) : null,
        })

        toggleChangelogLoading(false)
      } catch (err) {
        console.error('err', err)
        console.error('err.stack', err.stack)
      }
    }
    fetchLastUpdated()
  }, [])

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/cahras`)
        const {data} = response
        setReports(data)
        toggleLoadingReports(false)
      } catch (err) {
        console.error('err', err)
        console.error('err.stack', err.stack)
      }
    }
    fetchReports()
  }, [])

  useEffect(() => {
    if (hash === '') {
      return
    }

    if (!loadingReports) {
      window.location = hash
    }
  }, [hash, loadingReports])

  return (
    <Page id="cahras-list">
      <ScrollToTopButton />
      <Page.Header>LIST OF CAHRAS</Page.Header>
      <Page.Content>
        <p>For further information on a specific CAHRA, an individual report is available for download by clicking on the CAHRA’s name.</p>

        <p>For your convenience, the following archives (.zip) of CAHRA Reports are now available:</p>
        <ul>
          <li>
            <a href={`${apiUrl}/api/v1/cahras/archive`}>
              All CAHRA Reports
            </a>
          </li>
          {!isChangelogLoading && (
            <li>
              <a href={`${apiUrl}/api/v1/cahras/latest`}>
                Latest CAHRA Reports ({moment(changelog.reportsUpdated).format('MMMM YYYY')})
              </a>
            </li>
          )}
        </ul>

        { /* Display repease notes and dates */ }
        {changelog && (<Changelog data={changelog} />)}

        <p>Should you have any questions about the current indicative, non-exhaustive list of CAHRAs under Regulation (EU) 2017/821, please refer to our <a href="https://www.rand.org/randeurope/research/projects/identifying-conflict-affected-and-high-risk-areas-for-eu-importe.html#faqs" target={'_blank'} rel='noopener noreferrer'>Frequently Asked Questions</a> page.</p>

        {loadingReports && (
          <Loader active inline />
        )}

        <Card.Group itemsPerRow={4} stackable style={{marginBottom: "1rem"}}>
            {reports.map((record) => {
              const countryCode = get(record, 'country_code')
              const countryName = get(record, 'country_name')

              return (
                <Card key={`${countryCode}-anchor`}>
                  <Card.Content>
                    <a href={`#${countryCode}`}>
                      {countryName}
                    </a>
                  </Card.Content>
                </Card>
              )
            })}
        </Card.Group>

        <ReportAccordion
          reports={reports}
        />
      </Page.Content>
    </Page>
  )
}

export default CAHRAs
